import BaseView from 'components-framework/view/base.view';
import {convertXsellAccommodationRequest} from 'od-apps/app.flights';
import localforage from 'localforage';
import {createShoppingCartInDAPI} from 'od-modules/secure_store/reducers/asyncActionCreators';
import {dispatch} from 'od-modules/secure_store/store';

const trackingUtils = require('od-modules/utils/tracking.utils');
const RETRIES_SHOW_ALERT = 4;

const View = BaseView.extend({
    events: {
        'change .resident_checkbox': 'onChangeDiscount',
    },
    initialize() {
        this.listenTo(this.model, 'change:residentZones change:numPassengers change:residentDiscountApplied change:paxTypesNumber', this.render);
        this.listenTo(this.model, 'change:tripIatas change:tripType', this.model.getResidentZones.bind(this.model));
    },
    trackInit: function() {
        const initialized = this.model.get('initialized');
        if (!initialized) {
            trackingUtils.trackEvent('resident_discount', 'resident_discount_widget_onload');
            this.model.set('initialized', true);
        }
    },
    getRetries() {
        const times = parseInt(Odigeo.Session.get('residentDiscountTimesChanged'), 10) || 0;
        const shouldShowRetryAlert = Odigeo.AB.isResidentDiscountRetries && times > RETRIES_SHOW_ALERT;
        shouldShowRetryAlert && trackingUtils.trackEvent('resident_discount', 'resident_discount_abuse_msg_onload');
        return shouldShowRetryAlert;
    },
    appendResidentDiscountTemplate(numPassengers, residentZones) {
        const applied = this.model.get('residentDiscountApplied');
        const isUpdating = this.model.get('isUpdating');
        const initialized = this.model.get('initialized');
        const keys = this.keys;
        const titleKey = numPassengers === 1 ? keys.title : keys.plusTitle;
        const title = Odigeo.Utils.replaceCmsKeyArgs(titleKey, residentZones);
        const retries = !initialized && this.getRetries();
        const retryText = Odigeo.Utils.replaceCmsKeyArgs(keys.switchAlert, residentZones);
        if (residentZones) {
            const checked = applied ? 'checked' : '';
            this.$el.html(this.templates.main({
                applied,
                checked,
                residentZones,
                numPassengers,
                keys,
                title,
                retries,
                retryText,
            }));
            isUpdating && this.appendWaitingTemplate();
            this.trackInit();
        }
    },
    render() {
        const travellers = this.model.get('numPassengers');
        const residentZones = this.model.get('residentZones');
        if (travellers && residentZones) {
            this.appendResidentDiscountTemplate(travellers, residentZones);
        }
    },
    onChangeDiscount(e) {
        const times = parseInt(Odigeo.Session.get('residentDiscountTimesChanged'), 10) || 0;
        Odigeo.Session.set('residentDiscountTimesChanged', times + 1);
        const applied = e.target.checked;
        const label = applied ? 'resident_discount_widget_apply' : 'resident_discount_widget_remove';
        trackingUtils.trackEvent('resident_discount', label);
        this.dispatchNewShoppingCart(applied);
    },
    appendWaitingTemplate() {
        const keys = this.keys;
        this.$el.append(this.templates.waiting({keys}));
    },
    getDPFareItinerary() {
        const regex = /.*segmentKey0=(.*?);.*segmentKey1=(.*?);.*fareItineraryKey=(.*?);.*/;
        const dpData = Odigeo.Session.get('dynpackDeeplink') || '';
        const [, segment0, segment1, fareItineraryKey] = dpData.match(regex);
        return {segmentKeys: [segment0, segment1], fareItineraryKey};
    },
    getCreateShoppingCartData(applied, flowProduct) {
        const flightData = Odigeo.Utils.parseJson(Odigeo.Session.get('flightSelectionData')) || {};
        const dpData = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')) || {};
        const createShoppingCartData = Object.assign({resident: applied, residentToggle: true});
        if (flowProduct !== 'dp') {
            Object.assign(createShoppingCartData, convertXsellAccommodationRequest(flightData), flightData.data);
        } else {
            const externalSelectionDP = this.getDPFareItinerary();
            const externalSelection = Object.assign({}, dpData.externalSelectionRequest, externalSelectionDP);
            Object.assign(createShoppingCartData, {externalSelectionRequest: externalSelection});
        }
        return createShoppingCartData;
    },
    dispatchNewShoppingCart(applied) {
        localforage.clear();
        this.model.set('isUpdating', true);
        this.appendWaitingTemplate();
        const flowProduct = Odigeo.SessionScope.flowProduct;
        const page = Odigeo.SessionScope.flow === 'desktop' ? 'details' : 'passengersinfo';
        const isMeta = !Odigeo.Session.get('selectedCarriers');
        const createShoppingCartData = this.getCreateShoppingCartData(applied, flowProduct);
        dispatch(createShoppingCartInDAPI(createShoppingCartData, flowProduct, isMeta, (currentId, newId) => {
            Odigeo.Session.set('bookingId', newId);
            Odigeo.trigger('resident-discount-pax:updateProductsInSession', currentId, newId);
            this.model.set('isUpdating', false);
            Odigeo.Router.navigate(page, {bookingId: newId});
            if (Odigeo.AB.isGoBackNativeMessage) {
                window.onbeforeunload = null;
            }
        }));
    },
});

export default View;
